import React from "react";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import type { IncompleteReason } from "./incompleteReasonDetails";

export const CHIP_STYLE: {
  [k in IncompleteReason]: {
    color: React.CSSProperties["color"];
    backgroundColor: React.CSSProperties["backgroundColor"];
  };
} = {
  opt_out: { color: "shades.orange.600", backgroundColor: "shades.orange.50" },
  restricted: { color: "error.main", backgroundColor: "shades.negative.50" },
  error: { color: "error.main", backgroundColor: "shades.negative.50" },
  cancelled: {
    color: "shades.neutral.500",
    backgroundColor: "shades.neutral.50",
  },
};

export const ReasonChip = styled(Typography)(({ theme }) => ({
  width: "fit-content",
  fontSize: "0.8125rem",
  fontWeight: 500,
  borderRadius: theme.corners.xsmall,
  padding: "2px 4px",
}));
